import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Token-based auth: the JWT rides in the Authorization header. This works
// reliably across all browsers, mobile PWAs and access domains (unlike a
// SameSite/Secure cookie which some environments silently drop).
export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ccfi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const path = window.location.pathname;
    if (err?.response?.status === 401 && path !== "/login" && !path.startsWith("/portal")) {
      localStorage.removeItem("ccfi_token");
      localStorage.removeItem("ccfi_user");
      window.location.href = "/login";
    }
    // FastAPI 422 validation errors return `detail` as an ARRAY of objects.
    // Most toast handlers do `toast.error(e.response?.data?.detail)` — rendering
    // an object array crashes React (blank screen). Normalise to a string here.
    const detail = err?.response?.data?.detail;
    if (detail && typeof detail !== "string") {
      err.response.data.detail_raw = detail; // structured errors (e.g. won-guard) read this
      const msg = Array.isArray(detail)
        ? detail.map((d) => {
            const field = Array.isArray(d?.loc) ? d.loc[d.loc.length - 1] : "";
            return [field, d?.msg].filter(Boolean).join(": ");
          }).filter(Boolean).join(" · ")
        : JSON.stringify(detail);
      err.response.data.detail = msg || "Request failed — please check the form fields.";
    }
    return Promise.reject(err);
  }
);
